import * as process from 'process';

import { IS_STAGING } from './env';
export const GRAPHQL_ENDPOINT: string = `https://presentation.youversionapi${IS_STAGING ? 'staging' : ''}.com/graphql`;

export const SALT: string = process.env.NEXT_PUBLIC_APP_SALT ?? '';

export const APPID: string = process.env.NEXT_PUBLIC_FACEBOOK_INIT_APP_ID ?? '117344358296665';

export const APPLE_REDIRECT_URL: string = process.env.NEXT_PUBLIC_APPLE_REDIRECT_URL ?? '';

export const MIN_PASSWORD_LENGTH = 15;
